import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { clearAuthCredentials } from '../services/api'
import DetailOverlays from './DetailOverlays'

interface LayoutProps {
  children: React.ReactNode
}

const tabs = [
  { path: '/add', label: 'Add' },
  { path: '/', label: 'Balance' },
  { path: '/search', label: 'History' },
  { path: '/reports', label: 'Reports' },
]

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation()
  const navigate = useNavigate()

  const isActive = (path: string) => {
    if (path === '/add') return ['/add', '/upload', '/manual'].includes(location.pathname)
    if (path === '/') return location.pathname === '/'
    return location.pathname === path
  }

  const handleLogout = () => {
    clearAuthCredentials()
    window.location.reload()
  }

  return (
    <>
      <header className="app-header">
        <div className="header-inner">
          <div className="brand"><div className="logo">S</div><h1>SplitScan</h1></div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="icon-btn" style={{ width: 'auto', padding: '0 14px' }} onClick={() => navigate('/admin')} title="API key & database export">Settings</button>
            <button className="icon-btn" style={{ width: 'auto', padding: '0 14px' }} onClick={handleLogout} title="Log out">Log out</button>
          </div>
        </div>
      </header>

      <main className="app-main">
        <div className="view-anim" key={location.pathname}>{children}</div>
      </main>

      <DetailOverlays />

      <nav className="bottom glass">
        <div className="nav-inner">
          {tabs.map((t) => (
            <Link key={t.path} to={t.path} className={`tab${isActive(t.path) ? ' active' : ''}`}>{t.label}</Link>
          ))}
        </div>
      </nav>
    </>
  )
}

export default Layout
